'use client'

import { humanizeSeconds } from '@polaris/core/utils'
import { useRef, useState } from 'react'
import { useRemainingTime } from './hooks'
import type { StepRemainingTimeProps } from './step-remaining-time'

type StepRemainingTimeTextProps = StepRemainingTimeProps & {
  paused?: boolean
}

export const StepRemainingTimeText = ({
  startedAtMs,
  estimatedTimeMs,
  paused,
}: StepRemainingTimeTextProps) => {
  const prevPause = useRef(paused)
  const { remainingTimeMs } = useRemainingTime({
    startedAtMs,
    estimatedTimeMs,
  })
  const [freezedRemainingTime, setFreezedRemainingTime] =
    useState(remainingTimeMs)

  if (paused && !prevPause.current) {
    prevPause.current = paused
    setFreezedRemainingTime(remainingTimeMs)
  }

  const displayRemainingTime = paused ? freezedRemainingTime : remainingTimeMs

  return (
    <p className='text-secondary text-sm'>
      {displayRemainingTime <= 0 ? (
        'The trade is taking longer than expected'
      ) : (
        <>
          About{' '}
          <span className='text-primary'>
            {humanizeSeconds(displayRemainingTime / 1000)}
          </span>{' '}
          remaining
        </>
      )}
    </p>
  )
}
